import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { environment } from './../../../environments/environment';

@Component({
  selector: 'app-blog-details',
  imports: [CommonModule],
  templateUrl: './blog-details.component.html',
  styleUrl: './blog-details.component.scss'
})
export class BlogDetailsComponent implements OnInit  {

  blogsApiBaseUrl: string;
  
  constructor() {
    this.blogsApiBaseUrl = environment.blogsApiBaseUrl;
  }

  private route = inject(ActivatedRoute);
  private http = inject(HttpClient);

  blog: any;

  ngOnInit() {
    const id = this.route.snapshot.paramMap.get('id');
    this.http.get(this.blogsApiBaseUrl + `/blogs/${id}`).subscribe(res => {
      this.blog = res;
    });
  }

  formatJson(data: any): string {
    return JSON.stringify(data, null, 2);
  }

}
